import script from "./footer.vue?vue&type=script&setup=true&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&lang=js"

import "./footer.vue?vue&type=style&index=0&id=e501fa7c&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e501fa7c"]])

export default __exports__